import React from "react"

import globalStyles from "../../../../App.module.scss"

export default function TopicLayout({title, intro, diagram, useWhen, tradeOff, ruleOfThumb}) {
    return (
        <div className={globalStyles.article}>
            <h1>{title}</h1>
            <p>{intro}</p>

            {diagram}

            <h3>Use when</h3>
            <ul>
                {useWhen.map((guidance) => <li key={guidance}>{guidance}</li>)}
            </ul>

            <h3>Trade-offs</h3>
            <p>{tradeOff}</p>

            <h3>Rule of thumb</h3>
            <p>{ruleOfThumb}</p>
        </div>
    )
}
